<div class="row utils-bar" style="justify-content: space-between">
  @if (dataSource) {
    <div class="table-filter">
      <input #groupFilterInput (keyup)="applyFilter.next(groupFilterInput.value)" [value]="filter_string" placeholder="Search groups"/>
    </div>
  }
  <mat-paginator [showFirstLastButtons]="true"
    style="justify-self: flex-end;">
  </mat-paginator>
</div>
<div class="table-container">
  <table [dataSource]="dataSource"
    [matSortActive]="'name'"
    (matSortChange)="updateSort($event)"
    class="table table-striped user-table"
    mat-table matSort matSortDirection="asc">

    @for (column of columns; track column) {
      <ng-container [matColumnDef]="column">
        <th *matHeaderCellDef [mat-sort-header]="column" mat-header-cell>
          @if (column === 'edit') {
          }
          @if (column !== 'edit') {
            {{column | titlecaseForWire | removeUnderscore}}
          }
        </th>
        <td *matCellDef="let group;"
          mat-cell
          style="text-align: left;border:none;">
          @if (column === 'edit') {
            <i (click)="openDialog(group)" class="fa fa-edit" style="cursor:pointer;"></i>
          }
          @if (['created_on', 'changed_on'].includes(column)) {
            {{group.attributes[column] | stringDate }}
          }
          @if (!['created_on', 'changed_on'].includes(column)) {
            {{group.attributes[column]}}
          }
        </td>
      </ng-container>
    }

    <ng-container>
      <tr *matHeaderRowDef="columns; sticky: true" mat-header-row></tr>
      <tr *matRowDef="let row; columns: columns;" mat-row></tr>
    </ng-container>
  </table>
</div>
